export const RETURN_ITEM_PROCESS_DATA = {
  // boxes
  numberOfBoxes: 1,
  // [{ type, label, value }]
  returnReasons: [],
  preferenceDetails: '',
  defectiveDetails: '',
  // { description, images: [{ id, image: base64 }] }
  damageDetails: '',
  // DAMAGE, BOX, and PRODUCT images
  // [{ id, mediaType, image: base64, description }],
  images: [],
  // Damage details
  // this will be pushed into images at the submit
  // [{ description, images: [{ image: base64 }] }]
  //damageItems: [],
}
